<div class="top-loader" *ngIf="loading"></div>
<div>
    <div class="fs-4 fw-semibold mb-3">{{'searchassuredid' | translate}}</div>
    <div class="row mb-4">
        <div class="col-md-12 col-lg-6 col-xl-4 mb-2">
            <div class="d-flex align-items-center search gap-2 w-100">
                <input #searchInput pInputText id="search-card" [(ngModel)]="assuredID.value"
                    [placeholder]="'searchassuredid' | translate" [ngClass]="{'input-error': noDataAvailable}" />
                <button class="btn searchBtn" (click)="fetchAssuredData()">
                    <i *ngIf="!loading" class="pi pi-search"></i>
                    <mat-spinner *ngIf="loading" diameter="20"></mat-spinner>
                </button>
            </div>
        </div>
        <div class="col-md-12 col-lg-6 col-xl-8 mb-2" *ngIf="data">
            <div class="print-report-div flex-wrap d-flex gap-2 justify-content-end">
                <p-button [label]="'generalservices' | translate" (onClick)="createInsertClaim(1)"
                    [disabled]="isInsertClaimDisabled" *ngIf="showInsertServices" />
                <p-button [label]="'insertchronicmedication' | translate" (onClick)="createInsertClaim(2)"
                    [disabled]="isInsertClaimDisabled" *ngIf="showInsertChronicMedication" />
            </div>
        </div>
    </div>
    <div class="card p-3 border-0 shadow-sm" *ngIf="data">
        <div class="fs-6 fw-semibold d-flex flex-column">
            <span>{{data.assuredName || '-'}}</span>
            <span class="arabic">{{data.assuredNameA || '-'}}</span>
        </div>
        <div class="p-3">
            <div class="row">
                <div class="col-xl-8 ">
                    <div class="row">
                        <div class="col-12 col-md-4 mb-3">
                            <div class="d-flex gap-2">
                                <div>
                                    <i class="pi pi-calendar text-primary"></i>
                                </div>
                                <div>
                                    <strong>{{'dateofbirth' | translate}}</strong>
                                    <div>{{data.birthDate || '-' | date}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-4 mb-3">
                            <div class="d-flex gap-2">
                                <div>
                                    <i class="pi pi-envelope text-primary"></i>
                                </div>
                                <div>
                                    <strong>{{'assuredid' | translate}}</strong>
                                    <div>{{data.assuredID || '-'}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-4 mb-3">
                            <div class="d-flex gap-2">
                                <div>
                                    <i class="pi pi-calendar text-primary"></i>
                                </div>
                                <div>
                                    <strong>{{'startdate' | translate}}</strong>
                                    <div>{{data.startDate || '-' | date}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-4 mb-3">
                            <div class="d-flex gap-2">
                                <div>
                                    <i class="pi pi-user text-primary"></i>
                                </div>
                                <div>
                                    <strong>{{'gender' | translate}}</strong>
                                    <div>{{data.gender|| '-'}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-4 mb-3">
                            <div class="d-flex gap-2">
                                <div>
                                    <i class="pi pi-info-circle text-primary"></i>
                                </div>
                                <div>
                                    <strong>{{'status' | translate}}</strong>
                                    <div>{{data.statusName|| '-'}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-4 mb-3">
                            <div class="d-flex gap-2">
                                <div>
                                    <i class="pi pi-calendar text-primary"></i>
                                </div>
                                <div>
                                    <strong>{{'enddate' | translate}}</strong>
                                    <div>{{data.endDate|| '-' | date}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-4 mb-3">
                            <div class="d-flex gap-2">
                                <div>
                                    <i class="pi pi-map-marker text-primary"></i>
                                </div>
                                <div>
                                    <strong>{{'policy' | translate}}</strong>
                                    <div>{{data.policyStatus|| '-'}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-4 mb-3">
                            <div class="d-flex gap-2">
                                <div>
                                    <i class="pi pi-check-circle text-primary"></i>
                                </div>
                                <div>
                                    <strong>{{'employeestatus' | translate}}</strong>
                                    <div>{{data.employmentStatus|| '-'}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-4 mb-3">
                            <div class="d-flex gap-2">
                                <div>
                                    <i class="pi pi-book text-primary"></i>
                                </div>
                                <div>
                                    <strong>{{'customername' | translate}}</strong>
                                    <div>{{data.custName|| '-'}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-4 mb-3">
                            <div class="d-flex gap-2">
                                <div>
                                    <i class="pi pi-building text-primary"></i>
                                </div>
                                <div>
                                    <strong>{{'companydetails' | translate}}</strong>
                                    <div>{{data.companyName || '-'}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-4">
                    <div class="print-report-div">
                        <label for="" class="fw-semibold fs-6 mb-2">{{'phonenumber' | translate}}</label>
                        <div class="d-flex gap-2">
                            <div class="input-group flex-nowrap" style="direction: ltr;">
                                <span class="input-group-text">+218</span>
                                <input pInputText 
                                       id="phoneInput" 
                                       placeholder="911234567" 
                                       [(ngModel)]="phoneNumber"
                                       (input)="onPhoneNumberInput($event)"
                                       [disabled]="data.isVerified === true"
                                       maxlength="9" />
                            </div>
                            <p-button *ngIf="data.isVerified === false|| data.isVerified === null || data.isVerified === '' || data.contactNo === null" [label]="'sendotp' | translate" 
                                     icon="pi pi-send" 
                                     (onClick)="sendOTP()"
                                     [disabled]="isSendOTPDisabled || loading"
                                     [loading]="loading" />
                        </div>
                        <div class="py-2 d-flex flex-column gap-2">
                            <div class="d-flex justify-content-center align-items-center py-1 px-3 rounded-pill chip-green" *ngIf="data.isVerified === true">
                               <span style="direction: ltr;"> +{{data.contactNo}}</span> • {{'verified' | translate}} 
                            </div>
                            <div class="d-flex justify-content-center align-items-center py-1 px-3 rounded-pill chip-amber" *ngIf="!data.isVerified && data.contactNo !== null">
                                <span style="direction: ltr;"> +{{data.contactNo}}</span>  • {{'verifynumber' | translate}} 
                            </div>
                            <div class="d-flex justify-content-center align-items-center py-1 px-3 rounded-pill chip-red" *ngIf="data.contactNo === null">
                                {{'nophoneonfile' | translate}} — {{'addnumber' | translate}}
                            </div>
                        </div>
                        <div *ngIf="showOTPSection">
                            <p-button [label]="'skipfornow' | translate" icon="pi pi-step-forward" (onClick)="openSkipModal()" />
                        </div>
                        <div class="otp-section mt-3" *ngIf="showOTPSection">
                            <label class="fw-semibold fs-6 mb-2 d-block">{{'enterotpcode' | translate}}</label>
                            <div class="otp-input-container">
                                <div class="otp-inputs" style="direction: ltr;">
                                    <input 
                                        type="text" 
                                        class="otp-digit" 
                                        maxlength="1" 
                                        (input)="onOTPDigitInput($event, 0)"
                                        (keydown)="onOTPKeyDown($event, 0)"
                                        (paste)="onOTPPaste($event)"
                                        #otpInput0>
                                    <input 
                                        type="text" 
                                        class="otp-digit" 
                                        maxlength="1" 
                                        (input)="onOTPDigitInput($event, 1)"
                                        (keydown)="onOTPKeyDown($event, 1)"
                                        #otpInput1>
                                    <input 
                                        type="text" 
                                        class="otp-digit" 
                                        maxlength="1" 
                                        (input)="onOTPDigitInput($event, 2)"
                                        (keydown)="onOTPKeyDown($event, 2)"
                                        #otpInput2>
                                    <input 
                                        type="text" 
                                        class="otp-digit" 
                                        maxlength="1" 
                                        (input)="onOTPDigitInput($event, 3)"
                                        (keydown)="onOTPKeyDown($event, 3)"
                                        #otpInput3>
                                    <input 
                                        type="text" 
                                        class="otp-digit" 
                                        maxlength="1" 
                                        (input)="onOTPDigitInput($event, 4)"
                                        (keydown)="onOTPKeyDown($event, 4)"
                                        #otpInput4>
                                    <input 
                                        type="text" 
                                        class="otp-digit" 
                                        maxlength="1" 
                                        (input)="onOTPDigitInput($event, 5)"
                                        (keydown)="onOTPKeyDown($event, 5)"
                                        #otpInput5>
                                </div>
                                <div class="otp-actions  mt-3">
                                    <p-button 
                                        [label]="'verifyotp' | translate" 
                                        severity="primary"
                                        size="small"
                                        [disabled]="loading"
                                        [loading]="loading"
                                        (onClick)="verifyOTP()"
                                        icon="pi pi-check"
                                        class="me-2">
                                    </p-button>
                                    <p-button 
                                        *ngIf="otpTimer === 0"
                                        [label]="'resendotp' | translate" 
                                        severity="primary"
                                        size="small"
                                        text="true"
                                        icon="pi pi-refresh"
                                        class="text-white"
                                        [disabled]="loading"
                                        [loading]="loading"
                                        (onClick)="resendOTP()">
                                    </p-button>
                                </div>
                                <div class="otp-timer mt-3" *ngIf="otpTimer > 0 && remainingAttempts !== 0">
                                    <small class="text-muted fs-6 d-flex align-items-center">
                                        <i class="pi pi-clock me-1"></i>
                                        {{ 'toast.resendavailablein' | translate }} {{ formatTimer(otpTimer) }}
                                    </small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="print-report-div d-flex mt-4 justify-content-end" *ngIf="showFindLimitsButton">
        <p-button [label]="'findlimits' | translate" (onClick)="findLimits()" />
    </div>
    <div class="my-4" *ngIf="switchtolimit">
        <p-table [value]="medicalService" [tableStyle]="{'min-width': '60rem'}">
            <ng-template pTemplate="header">
                <tr>
                    <th>{{ 'medicalservice' | translate }}</th>
                    <th>{{ 'remaining' | translate }}</th>
                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-claim>
                <tr>
                    <td>{{ claim.ACCNTNAM }}</td>
                    <td>{{ claim.Remaining.toFixed(3) }}</td>
                </tr>
            </ng-template>
        </p-table>
    </div>

</div>
<div *ngIf="!data" class="d-flex justify-content-center align-items-center">
    <img src="../../assets/nodataavailable.png" alt="">
</div>

<!-- Skip Verification Modal -->
<p-dialog 
    [header]="'skipphoneverification' | translate" 
    [(visible)]="showSkipModal" 
    [modal]="true" 
    [style]="{width: '500px'}"
    [closable]="true"
    (onHide)="closeSkipModal()">
    
    <div class="skip-verification-content">
        <p class="mb-3 text-muted">{{'pleaseselectreasonforskippingphoneverification' | translate}}</p>
        
        <div class="skip-reasons mb-3">
            <div *ngFor="let reason of skipReasons" class="mb-2">
                <p-radioButton 
                    [value]="reason.value" 
                    [(ngModel)]="selectedSkipReason"
                    [inputId]="reason.value"
                    (onChange)="onSkipReasonChange()">
                </p-radioButton>
                <label [for]="reason.value" class="mx-2 cursor-pointer">{{ reason.labelKey | translate }}</label>
            </div>
        </div>
        
        <div class="custom-reason mb-3" *ngIf="isOtherSelected">
            <label for="customReason" class="form-label fw-semibold">{{'pleaseprovideyourreason' | translate}}:</label>
            <textarea 
                id="customReason"
                [(ngModel)]="customReason"
                placeholder="Please provide your reason for skipping verification..."
                rows="3"
                class="form-control w-100">
            </textarea>
        </div>
    </div>
    
    <ng-template pTemplate="footer">
        <div class="d-flex justify-content-end gap-2">
            <p-button 
                [label]="'cancel' | translate" 
                severity="secondary" 
                text="true"
                (onClick)="closeSkipModal()">
            </p-button>
            <p-button 
                [label]="'skipverification' | translate" 
                severity="danger"
                (onClick)="submitSkipVerification()">
            </p-button>
        </div>
    </ng-template>
</p-dialog>